const translate = (parent, prefix, language) =>
  parent[prefix + "_" + language] || parent[prefix + "_fr"]

export default translate
